import React from 'react';
import MomentUtils from '@date-io/moment';
import moment from 'moment/moment';

import { MuiPickersUtilsProvider, TimePicker as MuiTimePicker } from '@material-ui/pickers';

import TimeIcon from '../../../assets/icons/TimeIcon';

import './new-time-picker.scss';

const TimePicker = (props) => {
  const {
    value,
    onChange,
    initDate,
    withoutStyles = false,
    disabled,
    views = ['hours']
  } = props;

  return (
    <div className={`new-time-picker__container${withoutStyles ? ' new-time-picker__without-styles' : ''}`}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiTimePicker value={value || initDate || moment()} onChange={onChange} views={views} />
      </MuiPickersUtilsProvider>

      {!disabled && (
        <>
          <TimeIcon />
        </>
      )}
    </div>
  );
};

export default TimePicker;
